import React from "react";
import AddIcon from "@material-ui/icons/Add";
import Chip from "@material-ui/core/Chip";
import { Button, FormLabel, TextField } from "@material-ui/core";

import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";

import FormControl from "@material-ui/core/FormControl";
import MenuItem from "@material-ui/core/MenuItem";
import Paper from "@material-ui/core/Paper";
import Select from "@material-ui/core/Select";

class ChipArray extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      contents: {},
      dialogOpened: false,
      dialogPrimarySelection: "",
      dialogSecondarySelection: "",
      dialogSelectionValue: "",
    };
  }

  resetSelectState() {
    this.setState({
      dialogOpened: false,
      dialogPrimarySelection: "",
      dialogSecondarySelection: "",
      dialogSelectionValue: "",
    });
  }

  render() {
    return (
      <div
        style={{
          padding: "0.3rem 0.4rem 0.3rem 0.4rem",
          border: "1px solid grey",
        }}
        className="chiparray"
      >
        {this.renderAdditionDialog()}
        <FormLabel>{this.props.title}</FormLabel>
        {this.renderChips()}
        <Button
          color="primary"
          onClick={() => {
            this.setState({ dialogOpened: true });
          }}
        >
          <AddIcon />
        </Button>
      </div>
    );
  }

  renderChips() {
    return (
      <div>
        {Object.entries(this.state.contents).map(([key, value], _) => (
          <Chip
            key={key}
            label={this.renderChipLabel(key, value)}
            onDelete={() => this.handleChipDelete(key)}
          />
        ))}
      </div>
    );
  }

  renderChipLabel(key, value) {
    if (value.constructor === Object) {
      return (
        key +
        "-" +
        Object.entries(value).map(([inner_key, inner_value], _) =>
          this.renderChipLabel(inner_key, inner_value)
        )
      );
    }
    return key + ":" + value;
  }

  renderAdditionDialog() {
    return (
      <Dialog
        aria-labelledby="simple-dialog-title"
        open={this.state.dialogOpened}
        className="dialog"
      >
        <DialogTitle id="simple-dialog-title">
          {"Adding a new " + this.props.children_field_name}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {this.props.title}
          </DialogContentText>
          <div
            style={{ display: "flex", flexDirection: "column", gap: "0.4rem" }}
          >
            {this.renderDialogPrimaryOptions()}
            {this.renderDialogSecondaryOptions()}
            {this.renderDialogValuesField()}
          </div>
        </DialogContent>

        <DialogActions>
          <Button
            onClick={this.resetSelectState.bind(this)}
            variant="contained"
            color="default"
          >
            Cancel
          </Button>
          <Button
            onClick={this.renderHandleDialogConfirmed.bind(this)}
            variant="contained"
            color="primary"
            autoFocus
          >
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
    );
  }

  renderDialogPrimaryOptions() {
    return (
      <FormControl>
        <Select
          autoFocus
          value={this.state.dialogPrimarySelection}
          onChange={(event) =>
            this.setState({
              dialogPrimarySelection: event.target.value,
              dialogSecondarySelection: "",
              dialogSelectionValue: "",
            })
          }
          variant="outlined"
          className="textfield"
          component={Paper}
          elevation={2}
        >
          {this.props.selection_options.map((entry, i) => (
            <MenuItem key={"key-" + i} value={entry.id}>
              {entry.title}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    );
  }

  renderDialogSecondaryOptions() {
    for (let i = 0; i < this.props.selection_options.length; i++) {
      if (
        this.props.selection_options[i].id === this.state.dialogPrimarySelection
      ) {
        let subOptions = this.props.selection_options[i].subOptions;
        if (subOptions) {
          return (
            <FormControl>
              <Select
                autoFocus
                value={this.state.dialogSecondarySelection}
                onChange={(event) =>
                  this.setState({
                    dialogSecondarySelection: event.target.value,
                    dialogSelectionValue: "",
                  })
                }
                variant="outlined"
                className="textfield"
                component={Paper}
                elevation={2}
              >
                {subOptions.map((entry, i) => (
                  <MenuItem key={"key-" + i} value={entry.id}>
                    {entry.title}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          );
        } else {
          return <div />;
        }
      }
    }
    return <div />;
  }

  renderDialogValuesField() {
    for (let i = 0; i < this.props.selection_options.length; i++) {
      if (
        this.props.selection_options[i].id === this.state.dialogPrimarySelection
      ) {
        let valueType = this.props.selection_options[i].type;
        if (valueType) {
          return (
            <TextField
              value={this.state.dialogSelectionValue || ""}
              onChange={(event) =>
                this.setState({ dialogSelectionValue: event.target.value })
              }
              type={valueType}
              variant="outlined"
              className="textfield"
              component={Paper}
              elevation={2}
              InputLabelProps={{
                shrink: true,
              }}
            />
          );
        } else {
          return <div />;
        }
      }
    }
    return <div />;
  }

  renderHandleDialogConfirmed() {
    let newContents = { ...this.state.contents };

    // Leave dialogue box open if "Confirm" button clicked without a valid value.
    if (this.state.dialogSelectionValue === "") {
      return false;
    }

    let val = this.props.dialogSelectionValueIsInt
      ? parseInt(this.state.dialogSelectionValue)
      : this.state.dialogSelectionValue;

    if (this.state.dialogSecondarySelection) {
      const previousPrimaryContents =
        this.state.contents[this.state.dialogPrimarySelection] || {};
      let newPrimaryContents = { [this.state.dialogSecondarySelection]: val };
      newContents[this.state.dialogPrimarySelection] = {
        ...previousPrimaryContents,
        ...newPrimaryContents,
      };
    } else {
      newContents[this.state.dialogPrimarySelection] = val;
    }

    this.setState({
      contents: newContents,
    });
    this.resetSelectState();
    this.props.onChange(newContents);
  }

  handleChipDelete(key) {
    let newContents = { ...this.state.contents };
    delete newContents[key];
    this.setState({ contents: newContents });
    this.props.onChange(newContents);
  }
}

ChipArray.defaultProps = {
  dialogSelectionValueIsInt: false,
};

export default ChipArray;
